import React, { useState, useEffect, useCallback, useRef } from 'react';
import { DS } from '../ds';
const slides = [{
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/14EX4KARsPxUUMGvhmUtB4/alineadores2.png',
  alt: 'Alineadores invisibles junto a su estuche Alinova en un consultorio',
  label: 'Ortodoncia invisible',
  title: 'ALINEADORES\nINVISIBLES',
  sub: 'Tecnología de punta para una sonrisa perfecta',
  pill: '✓ Ortodoncia avanzada',
  align: 'center' as const,
  overlay: 'rgba(8,42,55,0.48)',
  objectPosition: '30% center',
  objectPositionTablet: '22% center',
  objectPositionMobile: '15% center'
}, {
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/hDLXEzwvi5y52SkiGs3b9M/invima.png',
  alt: 'Técnica de laboratorio dental certificado INVIMA revisando un alineador',
  label: 'Respaldo institucional',
  title: 'HABILITADO CON\nCERTIFICACIÓN INVIMA',
  sub: 'Fabricación bajo normativa colombiana vigente',
  pill: '✓ Registro sanitario activo',
  align: 'left' as const,
  overlay: 'rgba(8,42,55,0.52)',
  objectPosition: 'center 30%',
  objectPositionTablet: 'center 25%',
  objectPositionMobile: 'center 20%'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/9pP5XSWpRvoMmSLRQAEuY3/personalizacion.png',
  alt: 'Cajas kraft de kit de alineadores personalizadas con distintas marcas',
  label: 'Identidad de marca',
  title: 'PRODUCTO\nPERSONALIZADO',
  sub: 'Kit eco-premium con tu marca en cada entrega',
  pill: '✓ Caja kraft · Bolsa lino · Estuche',
  align: 'right' as const,
  overlay: 'rgba(8,42,55,0.45)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: 'center'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/6kVyF4PnmEjzBR4Js8skie/tiempos.png',
  alt: 'Laboratorio de producción Alinova con impresoras 3D y cajas listas para envío',
  label: 'Logística',
  title: 'TIEMPOS DE\nENTREGA EXPRESS',
  sub: 'Respuesta en menos de 24 horas',
  pill: '✓ Envío a toda Colombia',
  align: 'center' as const,
  overlay: 'rgba(8,42,55,0.48)',
  objectPosition: 'center 40%',
  objectPositionTablet: 'center 40%',
  objectPositionMobile: '65% center'
}];
const ChevronLeft = () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" data-id="element-510" data-mp="1o5ddal1sy6fz">
    <path d="M13.5 17L7.5 11L13.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-511" data-mp="1o7gbvth0t7wb" />
  </svg>;
const ChevronRight = () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" data-id="element-512" data-mp="visp1tgmiagn">
    <path d="M8.5 17L14.5 11L8.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-513" data-mp="1afjlpuywx82k" />
  </svg>;
export const HeroBannerSlider = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(1400);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    ro.observe(el);
    setWidth(el.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);

  // El conteo del carrusel solo arranca una vez la página terminó de cargar,
  // para que la primera imagen ya esté visible antes de que empiece a avanzar.
  useEffect(() => {
    if (document.readyState === 'complete') {
      setPageLoaded(true);
      return;
    }
    const handleLoad = () => setPageLoaded(true);
    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);
  const isMobile = width <= 640;
  const isTablet = width > 640 && width <= 1280;
  const goTo = useCallback((index: number) => {
    if (transitioning || index === current) return;
    setPrev(current);
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setPrev(null);
      setTransitioning(false);
    }, 500);
  }, [current, transitioning]);
  const next = useCallback(() => {
    goTo((current + 1) % slides.length);
  }, [current, goTo]);
  const prevSlide = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length);
  }, [current, goTo]);
  useEffect(() => {
    if (!pageLoaded) return;
    timerRef.current = setTimeout(next, 10000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [current, pageLoaded, next]);
  const slide = slides[current];
  const heroHeight = isMobile ? '580px' : isTablet ? '680px' : '800px';
  const contentPadding = isMobile ? '0 20px 46px' : isTablet ? '0 40px 48px' : '0 64px 56px';
  const titleFontSize = isMobile ? 'clamp(1.5rem, 7.2vw, 2.1rem)' : 'clamp(2rem, 5vw, 3.6rem)';
  const labelFontSize = isMobile ? '10px' : '11px';
  const labelPadding = isMobile ? '3px 11px' : '4px 14px';
  const subFontSize = isMobile ? '13px' : '15px';
  const pillFontSize = isMobile ? '11px' : '12px';
  const pillPadding = isMobile ? '4px 12px' : '5px 16px';
  const arrowSize = isMobile ? '34px' : '46px';
  const arrowInset = isMobile ? '10px' : '20px';
  return <div ref={containerRef} style={{
    position: 'relative',
    width: '100%',
    height: heroHeight,
    overflow: 'hidden',
    background: DS.color.tealDeep
  }} data-id="element-514" data-mp="1eaw7ezv7p7ru">
      {/* Slides */}
      {slides.map((s, i) => {
      const isActive = i === current;
      const isPrev = i === prev;
      return <div key={s.id} style={{
        position: 'absolute',
        inset: 0,
        opacity: isActive ? 1 : 0,
        transform: isActive ? 'scale(1)' : isPrev ? 'scale(1.04)' : 'scale(1)',
        transition: isActive ? 'opacity 0.6s ease, transform 6s ease' : isPrev ? 'opacity 0.5s ease, transform 0.5s ease' : 'none',
        zIndex: isActive ? 2 : isPrev ? 1 : 0
      }} data-id="element-515" data-mp="1s3u6oxarzk0o" data-mpi={i}>
            <img src={s.image} alt={s.alt} style={{
          position: 'absolute',
          inset: 0,
          objectFit: 'cover',
          objectPosition: isMobile ? s.objectPositionMobile : isTablet ? s.objectPositionTablet : s.objectPosition,
          width: '100%',
          height: '100%',
          display: 'block'
        }} data-id="element-516" data-mp="fo16egro8sth" />

            {/* Overlay oscuro */}
            <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: s.overlay
        }} data-id="element-517" data-mp="11xhnpvsk6s4z" />

            {/* Overlay gradiente inferior */}
            <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(8,42,55,0.7) 0%, transparent 55%)'
        }} data-id="element-518" data-mp="s7y5msco72b6" />
          </div>;
    })}

      {/* Contenido encima */}
      <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: contentPadding,
      textAlign: slide.align === 'center' ? 'center' : 'left',
      alignItems: slide.align === 'right' ? 'flex-end' : slide.align === 'center' ? 'center' : 'flex-start',
      transition: 'all 0.5s ease'
    }} data-id="element-519" data-mp="99vlaqv2htjp">
        <div key={`label-${current}`} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        padding: labelPadding,
        borderRadius: DS.radius.pill,
        background: 'rgba(255,255,255,0.12)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        border: '1px solid rgba(255,255,255,0.2)',
        marginBottom: isMobile ? '12px' : '16px',
        animation: 'slideUp 0.5s ease both'
      }} data-id="element-520" data-mp="retc4cxu8dlp">
          <div style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: DS.color.aquaLight
        }} data-id="element-521" data-mp="3uv9ydlyyxfq5" />
          <span style={{
          fontFamily: DS.font.body,
          fontSize: labelFontSize,
          fontWeight: 700,
          color: 'rgba(255,255,255,0.85)',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }} data-id="element-522" data-mp="1t33sydomxeke">
            {slide.label}
          </span>
        </div>

        <h2 key={`title-${current}`} style={{
        fontFamily: DS.font.heading,
        fontWeight: 800,
        fontSize: titleFontSize,
        color: '#fff',
        lineHeight: 1.12,
        letterSpacing: '-0.02em',
        margin: isMobile ? '0 0 10px' : '0 0 14px',
        whiteSpace: 'pre-line',
        textShadow: '0 2px 20px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.55s ease 0.05s both',
        maxWidth: isMobile ? '320px' : 'none'
      }} data-id="element-523" data-mp="2af205yzrqsmb">
          {slide.title}
        </h2>

        <p key={`sub-${current}`} style={{
        fontFamily: DS.font.body,
        fontSize: subFontSize,
        color: 'rgba(255,255,255,0.75)',
        margin: isMobile ? '0 0 16px' : '0 0 20px',
        fontWeight: 500,
        animation: 'slideUp 0.6s ease 0.1s both',
        maxWidth: isMobile ? '300px' : 'none'
      }} data-id="element-524" data-mp="3313kids4u0qm">
          {slide.sub}
        </p>

        <div key={`pill-${current}`} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: pillPadding,
        borderRadius: DS.radius.pill,
        background: `linear-gradient(135deg, ${DS.color.teal}55, ${DS.color.aqua}44)`,
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `1px solid ${DS.color.aqua}55`,
        animation: 'slideUp 0.65s ease 0.15s both',
        maxWidth: isMobile ? '300px' : 'none'
      }} data-id="element-525" data-mp="w53elnjn3250">
          <span style={{
          fontFamily: DS.font.body,
          fontSize: pillFontSize,
          fontWeight: 700,
          color: '#fff',
          letterSpacing: '0.04em',
          whiteSpace: isMobile ? 'normal' : 'nowrap'
        }} data-id="element-526" data-mp="1ots6cvyt1v43">
            {slide.pill}
          </span>
        </div>
      </div>

      {/* Flechas */}
      <button onClick={prevSlide} aria-label="Slide anterior" style={{
      position: 'absolute',
      left: arrowInset,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 20,
      width: arrowSize,
      height: arrowSize,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.12)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255,255,255,0.22)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all 0.22s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
    }} data-id="element-527" data-mp="2zjn7xscx0ylf">
        <ChevronLeft data-id="element-528" data-mp="1zbgw95glfdp9" />
      </button>

      <button onClick={next} aria-label="Siguiente slide" style={{
      position: 'absolute',
      right: arrowInset,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 20,
      width: arrowSize,
      height: arrowSize,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.12)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255,255,255,0.22)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all 0.22s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
    }} data-id="element-529" data-mp="2n349wlougs9l">
        <ChevronRight data-id="element-530" data-mp="bh3khoh6gc0v" />
      </button>

      {/* Dots */}
      <div style={{
      position: 'absolute',
      bottom: isMobile ? '14px' : '20px',
      right: isMobile ? '16px' : '64px',
      zIndex: 20,
      display: 'flex',
      gap: '6px',
      alignItems: 'center'
    }} data-id="element-531" data-mp="q4ydl5z3kieh">
        {slides.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Slide ${i + 1}`} style={{
        width: i === current ? isMobile ? '20px' : '32px' : '6px',
        height: '6px',
        borderRadius: '4px',
        background: i === current ? '#fff' : 'rgba(255,255,255,0.35)',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        transition: `all 0.3s ${DS.ease.smooth}`
      }} data-id="element-532" data-mp="3ouymsw0bk0x3" data-mpi={i} />)}
      </div>

      {/* Barra de progreso inferior */}
      <div key={`progress-${current}`} aria-hidden="true" style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: '3px',
      background: `linear-gradient(90deg, ${DS.color.aquaLight}, ${DS.color.aqua})`,
      animation: pageLoaded ? 'progressBar 10s linear both' : 'none',
      zIndex: 20
    }} data-id="element-533" data-mp="3awe6frahxu7x" />

      {/* Keyframes */}
      <style data-id="element-534" data-mp="1ufjjch1965nk">{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes progressBar {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </div>;
};